/**
 * Empty component that does not render anything. Used to avoid error logs of missing component registry
 * for a few symphony data fields
 * @param props
 * @constructor
 */
export const EmptyComponent = (_props: any) => {
  return null;
};
